const e = {
  page404: {
    title: "Det verkar som att du har gått vilse",
    message: "Har du gått vilse?",
    action_btn: "Tillbaka till start"
  },
  address: {
    title: "Adress",
    type: {
      personal: "Personlig",
      company: "Företag/Organisation"
    },
    organisation: {
      label: "Företagsnamn"
    },
    name: {
      first_name: "Förnamn",
      last_name: "Efternamn",
      label: "Namn"
    },
    contact_person: {
      first_name: "Förnamn",
      last_name: "Efternamn",
      label: "Kontaktperson"
    },
    street: {
      label: "Gata och nummer",
      address1: "Adress",
      address2: "Adress 2"
    },
    city: {
      label: "Stad"
    },
    postal_code: {
      label: "Postnr"
    },
    country_code: {
      label: "Land"
    },
    company_data: {
      title: "Företagsinformation"
    },
    company_id: {
      label: "Organisationsnr (xxxxxx-xxxx)"
    },
    tax_id: {
      label: "Moms-ID"
    },
    vat_id: {
      label: "VAT-nummer"
    }
  },
  empty_state: {
    title: "Här var det tomt..."
  },
  profile: {
    emails: {
      label: "E-postadress (lägg till flera genom att separera med kommatecken)"
    },
    email: {
      label: "E-post"
    },
    phone: {
      label: "Telefon",
      short: "Telefon"
    }
  },
  validation: {
    country_required: "Fyll i land här",
    company_id: {
      not_valid: "Felaktigt organisationsnummer"
    },
    tax_id: {
      not_valid: "Felaktigt momsnummer"
    },
    vat_id: {
      not_valid: "Felaktigt VAT-nummer"
    }
  },
  general: {
    back: "Tillbaka",
    cancel: "Avbryt",
    close: "Stäng",
    remove: "Ta bort",
    optional: "Valfritt",
    period: {
      months: "{period, plural, one {# månad} other {# månader}}",
      years: "{period, plural, one {# år} other {# år}}",
      explicit: "Period",
      short: {
        months: "{ period, plural, one {månad} other {# månader} }",
        years: "{ period, plural, one {år} other {# år} }"
      },
      next: {
        months: "{ period, plural, one {nästa månad} other {kommande #  månader} }",
        years: "{ period, plural, one {nästa år} other {kommande # år} }",
        short: {
          months: "{ period, plural, one {nästa månad} other {kommande #  månader} }",
          years: "{ period, plural, one {nästa år} other {kommande #  år} }"
        }
      },
      per: {
        months: "{ period, plural, one {månadsvis} other {för #  månader} }",
        years: "{ period, plural, one {årsvis} other {för #  år} }",
        short: {
          months: "{ period, plural, one {/månad} other {/#  månader} }",
          years: "{ period, plural, one {/år} other {/#  år} }"
        }
      }
    },
    or: "eller",
    recommended: "rekommenderas",
    settings: "Inställningar",
    edit: "Redigera",
    save: "Spara",
    save_changes: "Spara ändringar",
    reset_form: "Återställ formulär",
    not_available: "Ej tillgänglig",
    unknown_error: "Okänt fel",
    unknown_error_id: "Okänt fel ({id})",
    something_went_wrong: "Ett oväntat fel uppstod",
    link: "länk",
    buy: "beställ"
  },
  capslock_hint: {
    line1: "Caps lock",
    line2: "är på"
  },
  ws_array_input: {
    some_filtered: "Vissa resultat är inte giltiga."
  },
  ws_places_input: {
    no_results: "Platsen kunde inte hittar, vänligen försök med din postort"
  },
  ws_uploader: {
    validation: {
      file_type: "Filtypen är ej godkänd.",
      file_size: "Filstorleken är över gränsen ({limit})"
    },
    status: {
      label: "Status",
      value: {
        uploaded: "Uppladdat",
        uploading: "uppladdning pågår",
        failed: "misslyckades",
        idle: "inaktiv"
      }
    },
    action: {
      title: "Ladda upp fakturor",
      text1: "Dra och släpp eller",
      link: "välj fil",
      text2: ".",
      abort_tooltip: "Avbryt uppladdning"
    },
    remove_btn: "Ta bort"
  },
  ws_table: {
    filter: {
      fulltext_title: "Fulltextsök",
      data_title: "Sök",
      clear_filters: "Rensa alla filter",
      from: "Från",
      to: "Till"
    },
    label: {
      bulk_actions: "Massåtgärder",
      cancel_selection: "Avbryt val",
      item_selected: "valda objekt",
      selected: "Valda",
      filterby: "Filtrera",
      records_per_page: "Antal per sida",
      select_all: "Välj alla"
    }
  },
  ws_password_strength: {
    rule1: "minst 8 tecken",
    rule2: "små och stora bokstäver",
    rule3: "minst en siffra",
    rule4: "minst ett specialtecken"
  },
  ws_password_confirmation_input: {
    passwords_do_not_match: "Lösenorden stämmer inte överens!"
  },
  ws_two_factor_authentication_input: {
    on_cooldown_one: "You can resend the code again in {{count}} second.",
    on_cooldown_few: "You can resend the code again in {{count}} seconds.",
    on_cooldown_other: "You can resend the code again in {{count}} seconds.",
    resend_code: "Resend code",
    code_being_sent: "Sending 2FA code...",
    code_sent_successfully: "2FA code sent successfully",
    error_sending_code: "Error sending 2FA code",
    invalid_code_pasted: "Ogiltig 2FA-kod klistrades in. Vänligen ange en giltig 2FA-kod."
  },
  generate_random: "Generera nytt",
  copy: {
    copy: "Kopiera",
    copied: "Kopierad",
    saved_in_clipboard: "Sparat i urklipp"
  },
  out_modal: {
    title: "Din webbläsare <br>är ej uppdaterad",
    text: "Du behöver uppgradera till den senaste versionen eller försök med en annan webbläsare",
    delimiter_text: "Vi hjälper till"
  },
  buttons: {
    ok_thanks: "Okej, tack!"
  },
  payment_cards: {
    ending_with: "Slutar med",
    active: "Aktiv"
  },
  ws_sub_items_price_summary: {
    current_price: "Pris (nuvarande period)",
    due_now: "Att betala nu",
    next_period_subtraction_warning: "*Priset dras av från nästa faktura",
    next_price: "Pris (nästa period)"
  },
  dialog_footer: {
    cannot_submit_empty_form: "Formuläret är tomt"
  },
  price_badge: {
    including_vat: "(inklusive moms)",
    excluding_vat: "(exkl. moms)"
  },
  login_pages: {
    footer: {
      help: "Hjälp",
      terms: "Villkor",
      privacy: "Integritet"
    },
    help: {
      title: "Need any help?",
      text: "You can always have a look at our <a href='{kb_url}' target='_blank'>knowledge database </a> or contact our <a href='{support_url}' target='_blank'>support</a>."
    }
  },
  message_service: {
    error: {
      axios: {
        title: "Network Error",
        text: "Unable to connect"
      },
      unexpected: {
        title: "Error",
        text: "Unexpected error"
      }
    }
  }
}, t = {
  wsk: e
};
export {
  t as default,
  e as wsk
};
//# sourceMappingURL=wsk.sv-SE-d9085144.js.map
